import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@mui/styles';
import { withTranslation } from 'react-i18next';
import AvatarGroup from '@mui/lab/AvatarGroup';
import Avatar from '@mui/material/Avatar';
import { withRouter } from 'react-router-dom';

const styles = (theme) => ({
    root: {
        width: '100%',
    },
    noTeamSpan: {
        fontWeight: '500',
        fontSize: '14px',
    },
    avatar: {
        cursor: 'pointer',
    },
});

class YourTeamPreview extends React.Component {
    render() {
        const { yourteam, assignmentLink, classes, history } = this.props;
        const items = [];
        // Customer Care Specialist is only used in Day One Details, so we filter it out here
        const filteredTeam = yourteam.filter(
            (member) => member.role !== 'Customer Care Specialist'
        );

        if (!filteredTeam || filteredTeam.length === 0) {
            return <span className={classes.noTeamSpan}>Your team will be assigned soon.</span>;
        }

        for (let i = 0; i < filteredTeam.length; i++) {
            items.push(<Avatar key={`avatar-${i + 1}`} src={filteredTeam[i].image} />);
        }

        return (
            <AvatarGroup
                onClick={(e) => (assignmentLink ? history.push(assignmentLink) : () => false)}
                spacing="medium"
                max={4}
                classes={{ avatar: classes.avatar }}
                className="assignmentSupportTeam"
            >
                {items}
            </AvatarGroup>
        );
    }
}

YourTeamPreview.propTypes = {
    classes: PropTypes.object.isRequired,
};

export default withRouter(withTranslation()(withStyles(styles)(YourTeamPreview)));
